import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import { firstValueFrom } from 'rxjs';

import { EtapasBeneficioComponent } from '../../shared/components/etapas-beneficio/etapas-beneficio.component';
import { SessionService } from '../../core/services/session.service';
import { BeneficiaryService } from '../../core/services/beneficiary.service';
import { DocumentosService } from '../../core/services/documentos.service';
import { ProcessoService, TipoAposentadoria } from '../../core/services/processo.service';

@Component({
  selector: 'app-abrir-processo',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    EtapasBeneficioComponent,
  ],
  templateUrl: './abrir-processo.component.html',
  styleUrl: './abrir-processo.component.scss',
})
export class AbrirProcessoComponent implements OnInit {
  beneficiario: any = '';
  dadosPessoais: any = null;
  abrindo = false;
  tentativa:any=null;
  evidencia='';
  nupConferido='';
  ausenciaConfirmada=false;
  conciliando=false;
  carregarTentativa():void {
    this.processoService.consultarTentativa(this.beneficiario.matricula,this.beneficiario.orgao.id).subscribe({
      next:r=>this.tentativa=r,
      error:err=>this.snackBar.open(err.error?.detail??'Não foi possível consultar a tentativa.','Fechar',{duration:6000})
    });
  }
  conciliar():void {
    this.conciliando=true;
    this.processoService.conciliarTentativa(this.beneficiario.matricula,this.beneficiario.orgao.id,{nup:this.nupConferido,justificativa:this.evidencia,ausenciaConfirmada:this.ausenciaConfirmada}).subscribe({
      next:()=>{this.conciliando=false;this.carregarTentativa();this.snackBar.open('Conferência registrada.','Fechar',{duration:4000});},
      error:err=>{this.conciliando=false;this.snackBar.open(err.error?.detail??err.error?.message??'Falha ao registrar conferência.','Fechar',{duration:7000});}
    });
  }
  retomarRegistro():void {
    if(!this.tentativa?.numeroProcesso||!this.tentativa?.pedidoOriginal)return;
    this.abrindo=true;
    this.processoService.criarProcesso(this.tentativa.pedidoOriginal).subscribe({
      next:()=>{this.abrindo=false;this.carregarTentativa();this.snackBar.open('Registro local concluído com o NUP já existente.','Fechar',{duration:6000});},
      error:err=>{this.abrindo=false;this.carregarTentativa();this.snackBar.open(err.error?.detail??err.error?.mensagem??'Não foi possível retomar o registro.','Fechar',{duration:7000});}
    });
  }


  // Atestar
  atestado = false;

  // Checklist Instituidor
  checklist = {
    cpf: false,
    nome: false,
    rg: false,
    nascimento: false,
  };

  // Assunto
  assuntoSelecionado: TipoAposentadoria | '' = '';
  assuntos: { label: string; value: TipoAposentadoria }[] = [
    { label: 'Reserva remunerada - a pedido', value: 'RESERVA_REMUNERADA_A_PEDIDO' },
    { label: 'Reserva remunerada - ex officio', value: 'RESERVA_REMUNERADA_EX_OFFICIO' },
    { label: 'Reforma por incapacidade', value: 'REFORMA_POR_INCAPACIDADE' },
    { label: 'Reforma por idade', value: 'REFORMA_POR_IDADE' },
    { label: 'Reforma por tempo de contribuição', value: 'REFORMA_POR_TEMPO_DE_CONTRIBUICAO' },
  ];

  constructor(
    private sessionService: SessionService,
    private beneficiarioService: BeneficiaryService,
    private processoService: ProcessoService,
    private documentosService: DocumentosService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.beneficiario = this.sessionService.beneficiario;
    if(!this.beneficiario?.matricula || !this.beneficiario?.orgao?.id)return;
    this.carregarTentativa();

    this.beneficiarioService
      .getDadosPessoais(this.beneficiario.matricula, this.beneficiario.orgao.id)
      .subscribe({
        next: (res: any) => {
          this.dadosPessoais = res;
        },
        error: (err: any) => {
          console.error('Erro ao carregar dados pessoais', err);
        },
      });
  }

  podeAbrir(): boolean {
    return (
      this.atestado &&
      this.checklist.cpf &&
      this.checklist.nome &&
      this.checklist.rg &&
      this.checklist.nascimento &&
      !!this.assuntoSelecionado
    );
  }

  async abrirProcesso(): Promise<void> {
    if (!this.podeAbrir() || !this.assuntoSelecionado) return;

    this.abrindo = true;

    // Bloqueia a abertura enquanto houver documento anexado sem assinatura.
    try {
      const pendentes = await this.documentosNaoAssinados();
      if (pendentes.length > 0) {
        this.abrindo = false;
        const nomes = pendentes.slice(0, 4).join(', ');
        this.snackBar.open(
          `Não é possível abrir o processo: ${pendentes.length} documento(s) ainda não assinado(s): ` +
          `${nomes}${pendentes.length > 4 ? '...' : ''}. Assine os documentos antes de abrir.`,
          'Fechar',
          { duration: 8000, horizontalPosition: 'right', verticalPosition: 'bottom' }
        );
        return;
      }
    } catch (err) {
      // Sem como validar aqui (falha na consulta): avisa e deixa o backend decidir.
      console.error('Falha ao verificar documentos pendentes de assinatura', err);
      this.snackBar.open(
        'Não foi possível verificar os documentos pendentes de assinatura. A abertura seguirá com a validação do servidor.',
        'Fechar',
        { duration: 6000, horizontalPosition: 'right', verticalPosition: 'bottom' }
      );
    }

    this.processoService
      .criarProcesso({
        matricula: this.beneficiario.matricula,
        idOrgao: this.beneficiario.orgao.id,
        tipoAposentadoria: this.assuntoSelecionado,
      })
      .subscribe({
        next: (res: any) => {
          this.abrindo = false;
          this.carregarTentativa();
          const numero = res?.numeroProcesso ?? res?.numero ?? '';
          const mensagem = numero
            ? `Processo ${numero} cadastrado com sucesso`
            : 'Processo cadastrado com sucesso';
          this.snackBar.open(mensagem, 'Fechar', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        },
        error: (err: any) => {
          this.abrindo = false;
          this.carregarTentativa();

          // O backend responde erros de negócio no campo "mensagem"; o 409 de
          // processo já aberto traz também o número do processo existente.
          let detalhe: string =
            err?.error?.detail ?? err?.error?.mensagem ?? err?.error?.message ?? err?.message ?? 'Falha ao abrir processo';
          if (err?.status === 409) {
            const numero = err?.error?.numeroProcesso;
            detalhe = numero
              ? `Já existe um processo aberto para este militar (nº ${numero}).`
              : err?.error?.detail ?? err?.error?.mensagem ?? 'Já existe um processo aberto para este militar.';
          }

          this.snackBar.open(detalhe, 'Fechar', {
            duration: 6000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        },
      });
  }

  /**
   * Nomes dos documentos sem assinatura, com a mesma lista e o mesmo critério da conferência do
   * servidor: lista pré-processo (qualquer origem) e bloqueia todo documento sem assinado = verdadeiro.
   * O nome segue a mensagem do servidor: arquivo, depois nome do tipo.
   */
  private async documentosNaoAssinados(): Promise<string[]> {
    const docs = await firstValueFrom(
      this.documentosService.listarPreProcesso(this.beneficiario.matricula, this.beneficiario.orgao.id)
    );
    return (docs ?? [])
      .filter((d) => d.assinado !== true)
      .map((d) => d.nomeArquivo?.trim() || d.tipoDocumentoNome?.trim() || `Documento ${d.id}`);
  }
}
